export { default } from './entities-carousel';
